import { useContext } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getStudentImage } from '../../../common/styles/Images';
import { Tooltip } from 'bootstrap';
  
const CurrentJobInformationRightPanel = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const userData = state.data?.user;

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl);
            });

    return (
        <div className="rightPaneBodyWrap">
            <div className="rightPaneBody" data-aos="fade-left">
                <div className="step step_1">
                    <h2 className="stepHeader text-center">
                        Your profile card is <span className="text-danger font-600">missing</span> your
                        <br className="d-none d-lg-block" />{' '}
                        <span className="text-danger font-700 header-highlight">Current Information</span>
                    </h2>

                    <div className="step_img mt-3">
                        <div className="missing mt-5">
                            <div className="alumni-bucket">
                                <div className="alumni_class_link">
                                    <div className="alumni_name_detail">
                                        <div className="alumni_img">
                                            <a className="alumni_img_link w-100 h-100" href="javascript:;">
                                                <img src={getStudentImage({ profilePictureFilePath: state?.data?.profile?.profilePictureFilePath, genderCode:state?.data?.profile?.genderCode })} alt={`${userData?.firstName} ${userData?.lastName}`} />
                                            </a>
                                        </div>
                                        <div className="alumni_name_brife">
                                            <h3>
                                                <a className="alumni_name_link" href="javascript:;">
                                                    {userData?.firstName} {userData?.lastName}!
                                                </a>
                                            </h3>
                                            <span className="alumni_campus">{userData?.programName}, {state?.data?.selectedInstitute?.passOutYear}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="alumni_univarsity_details bg-baige">
                                    <div className="alumni_univarsity_details_inner_cover">
                                        <div className="alumni_univarsity_logo univarsity_logo">
                                            {/* <i className="bi bi-question-lg font-32 text-danger position-static bg-transparent w-auto"></i> */}
                                            <img
                                                src={props.data?.entityLogo}
                                                width="46"
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="alumni_univarsity_brife">
                                            <div className="alumni_education">
                                                <div className="row g-2">
                                                    <div className="col">{props.data?.currentStatus}</div>
                                                </div>
                                            </div>
                                            <div className="alumni_univarsity_name">
                                                <span className="text-danger" data-bs-toggle='tooltip' data-bs-original-title={props.data?.entityHeading}>{props.data?.entityHeading}</span>
                                            </div>
                                            {props.data?.entitySubHeading &&<div className="alumni_univarsity_subject">
                                                <i className=""></i>
                                                <span className="text-danger font-500  mt-0">{props.data?.entitySubHeading}</span>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="font-style text-danger">
                                    Missing
                                    <br /> Information.
                                </div>
                            </div>
                        </div>
                        <div className="full-info mt-5">
                            <div className="alumni-bucket">
                                <div className="alumni_class_link">
                                    <div className="alumni_name_detail">
                                        <div className="alumni_img">
                                            <a className="alumni_img_link" href="javascript:;">
                                                <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/card-placeholder-img-2.png" alt="Sreeharsha Shankar" />
                                            </a>
                                        </div>
                                        <div className="alumni_name_brife">
                                            <h3>
                                                <a className="alumni_name_link" href="javascript:;">
                                                    Sreeharsha Uday
                                                </a>
                                            </h3>
                                            <span className="alumni_campus">12 Class, 2022</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="alumni_univarsity_details bg-baige">
                                    <div className="alumni_univarsity_details_inner_cover">
                                        <div className="alumni_univarsity_logo univarsity_logo">
                                            <img
                                                src={props.data?.currentStatus!=='Working As' ? "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/uc-berkeley.png" : "https://www.univariety.xyz/prototype/school_dashboard/images/meta.svg"}
                                                width="46"
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="alumni_univarsity_brife">
                                            <div className="alumni_education">
                                                <div className="row g-2">
                                                    <div className="col">{props.data?.currentStatus}</div>
                                                </div>
                                            </div>
                                            <div className="alumni_univarsity_name">
                                                <span>{props.data?.currentStatus==='Working As' ? 'Meta (Facebook)' : 'UC Berkeley'}</span>
                                            </div>
                                            <div className="alumni_univarsity_subject">
                                                <i className=""></i>
                                                <span>{props.data?.currentStatus==='Working As' ? 'Program Manager' : 'Economics & Commerce'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="font-style text-dark-blue">
                                    Sample card with
                                    <br /> full Information.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CurrentJobInformationRightPanel